// Copyright (c) 2016 Deere & Company

import actions from '../../../../sharedmodules/actions-list';

export const updateSearchDivisionParam = (value) => ({
    type: actions.UPDATE_DEALER_SEARCH_DIVISION_PARAMS,
    value,
});
